import React from "react";
import { Button, Radio, RadioGroup, TextField } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { roles } from "../../../sidenav/constant";
import { toast } from "react-toastify";
import { SessionAPI } from "../../../../utils/services/session-management";

const QuizQuestions = ({
  sessionId,
  formType,
  questions,
  setquestions,
  editableQuestions,
  setEditableQuestions,
  handleAddQuiz,
  handleRemoveClick,
  handleRemoveEditable,
  handleUpdateQuestion,
  quizId,
  role,
  levelPermission,
}) => {
  console.log(questions);

  const updateQuestion = (index, newQuestion) => {
    console.log(newQuestion, "question teasdasascs");

    setEditableQuestions((prevEditableQuestions) => {
      // Create a copy of the previous state
      const updatedEditableQuestions = [...prevEditableQuestions];

      // Update the question for the object at the specified index
      updatedEditableQuestions[index] = {
        ...updatedEditableQuestions[index],
        question: newQuestion?.length === 0 ? null : newQuestion,
      };

      return updatedEditableQuestions;
    });
  };

  const handleAddQuestion = async (question, index) => {
    const isQuestionValid = () =>
      question.question !== null && // Check if the question is not empty
      question.correctAnswer !== null && // Check if the correctAnswer is set
      question?.options.filter((op) => op.text !== null).length >= 2;

    if (!isQuestionValid()) {
      toast.error("Please fill in all required fields for the question");
      return;
    }

    const createQuestionsPayload = {
      questions: [question],
    };

    const { payload } = await SessionAPI.addQuestion(
      quizId,
      createQuestionsPayload
    );

    if (payload) {
      toast.success("Question added successfully!");
      handleRemoveClick(index)
      setEditableQuestions(payload);
    }
  };

  const updateCorrectAnswer = (index, optionId) => {
    const arr = [...editableQuestions];
    if (
      arr[index].options[optionId - 1].text !== null ||
      arr[index].options[optionId - 1].text !== ""
    ) {
      arr[index].correctAnswer = optionId;
      setEditableQuestions(arr);
    }
  };

  const updateOptionText = (quesIndex, optionIndex, newText) => {
    const arr = [...editableQuestions];
    if (newText === "") {
      arr[quesIndex].options[optionIndex].text = null;
      if (
        arr[quesIndex]?.correctAnswer == arr[quesIndex].options[optionIndex].id
      ) {
        arr[quesIndex].correctAnswer = null;
      }
    } else {
      arr[quesIndex].options[optionIndex].text = newText;
    }
    setEditableQuestions(arr);
  };

  const handleOptionTextChange = (event, quesIndex, optionIndex) => {
    const arr = [...questions];
    const value = event.target.value;
    if (value === "") {
      arr[quesIndex].options[optionIndex].text = null;
      if (
        arr[quesIndex]?.correctAnswer == arr[quesIndex].options[optionIndex].id
      ) {
        arr[quesIndex].correctAnswer = null;
      }
    } else {
      arr[quesIndex].options[optionIndex].text = value;
    }
    setquestions(arr);
  };

  return (
    <div>
      {formType === "edit" && (
        <div>
          {editableQuestions?.map((question, index) => {
            // console.log()
            const count = index + 1;
            return (
              <>
                <div
                  style={{ backgroundColor: "white" }}
                  className="mock-test-quetion-div"
                >
                  <div
                    className="quetion-nu"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "1rem",
                    }}
                  >
                    <b>Questions {count} </b>
                    {(role === "Admin" ||
                      (role === roles.SUB_ADMIN && levelPermission)) && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DeleteOutlineIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            handleRemoveEditable(index, question.id)
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="content-filed">
                    <TextField
                      value={question?.question}
                      size="small"
                      multiline
                      disabled={role === roles.SUB_ADMIN && !levelPermission}
                      onChange={(e) => updateQuestion(index, e.target.value)}
                      rows={3}
                      fullWidth
                      placeholder="Question Goes Here*"
                      label="Question Goes Here*"
                    />
                    <div>
                      {/* <FormControl> */}
                      <RadioGroup
                        value={question?.correctAnswer}
                        // onChange={(event) => {
                        //   const arr = [...questions];
                        //   arr[index].correctAnswer = event.target.value;
                        //   setquestions(arr);
                        // }}
                        disabled={role === roles.SUB_ADMIN && !levelPermission}
                        onChange={(e) =>
                          updateCorrectAnswer(index, e.target.value)
                        }
                        style={{
                          margin: "1.5rem 0rem",
                          display: "flex",
                          gap: "1.5rem",
                        }}
                      >
                        {question?.options?.map((option, optionIndex) => (
                          <div className="quiz-option">
                            <div>
                              <Radio
                                value={option?.id}
                                size="small"
                                disabled={
                                  role === roles.SUB_ADMIN && !levelPermission
                                }
                              />
                            </div>
                            <TextField
                              size="small"
                              className="option-input"
                              value={question?.options[optionIndex]?.text}
                              placeholder={`Option ${option?.id}`}
                              disabled={
                                role === roles.SUB_ADMIN && !levelPermission
                              }
                              onChange={(e) =>
                                updateOptionText(
                                  index,
                                  optionIndex,
                                  e.target.value
                                )
                              }
                              label={`Option ${option?.id}`}
                            />
                          </div>
                        ))}
                      </RadioGroup>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      textTransform: "none",
                      marginBottom: "2rem",
                      borderRadius: "0.25rem",
                    }}
                    onClick={() => handleUpdateQuestion(index, question)}
                  >
                    Update Question
                  </Button>
                </div>
              </>
            );
          })}
        </div>
      )}

      {questions?.map((question, index) => {
        const count = index + 1;

        const incCount = editableQuestions.length + count;
        return (
          <>
            <div
              style={{ backgroundColor: "white" }}
              className="mock-test-quetion-div"
            >
              <div
                className="quetion-nu "
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "1rem",
                }}
              >
                <b>Questions {formType === "edit" ? incCount : count} </b>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <DeleteOutlineIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRemoveClick(index)}
                  />
                </div>
              </div>
              <div className="content-filed">
                <TextField
                  value={question?.question}
                  size="small"
                  // onChange={handleSuitableFor}
                  // value={SuitableFor}
                  multiline
                  onChange={(event) => {
                    const arr = [...questions];
                    const value = event.target.value;
                    arr[index].question = value.length === 0 ? null : value;
                    setquestions(arr);
                  }}
                  rows={3}
                  fullWidth
                  placeholder="Question Goes Here*"
                  label="Question Goes Here*"
                />
                <br />
                <br />
                <div className="quetion-checkbox">
                  {/* <FormControl> */}
                  <RadioGroup
                    value={question?.correctAnswer}
                    onChange={(event) => {
                      const arr = [...questions];
                      const optionId = event.target.value;
                      if (arr[index].options[optionId - 1].text !== null) {
                        arr[index].correctAnswer = optionId;
                        setquestions(arr);
                      }
                    }}
                    style={{
                      margin: "1.5rem 0rem",
                      display: "flex",
                      gap: "1.5rem",
                    }}
                  >
                    {question?.options?.map((opt, optionIndex) => (
                      <div className="quiz-option">
                        <Radio size="small" value={opt?.id} />
                        <TextField
                          size="small"
                          className="option-input"
                          value={question?.options[optionIndex]?.text}
                          placeholder={`Option ${opt?.id}`}
                          onChange={(event) =>
                            handleOptionTextChange(event, index, optionIndex)
                          }
                          label={`Option ${opt?.id}`}
                        />
                      </div>
                    ))}
                  </RadioGroup>
                </div>
              </div>

              {formType === "edit" && (
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    textTransform: "none",
                    borderRadius: "0.25rem",
                    marginBottom: "2rem",
                  }}
                  onClick={() => handleAddQuestion(question, index)}
                >
                  Add Question
                </Button>
              )}
            </div>
          </>
        );
      })}

      {(role === "Admin" || (role === roles.SUB_ADMIN && levelPermission)) && (
        <div className="add-new-quaestion">
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              color: "#1A5AFA",
              border: "1px solid #1A5AFA",
            }}
            onClick={handleAddQuiz}
          >
            <b>Add New Questions</b>
          </Button>
        </div>
      )}

      {/* <div className="save-discard-btn">
        <Button
          variant="contained"
          onClick={FinalPublish}
          color="primary"
          sx={{ textTransform: "none", backgroundColor: "#1A5AFA" }}
        >
          Publish
        </Button>
      </div> */}
    </div>
  );
};

export default QuizQuestions;
